import { BaseTestResultData } from "../../Common/Testing/BaseTestResultData";
import { TestResultDataType } from "../../Common/Testing/TestResultDataType";
import { FlowConfiguration } from "../FlowConfiguration";
import { FlowStepSequence } from "./FlowStepSequence";
import { DataUtilities } from "../../Common/DataUtilities";
import { FlowStepData } from "../Steps/FlowStepData";

export abstract class BaseFlowTestContext extends BaseTestResultData {
    private _startData: Object = {};

    get startData(): Object {
        return this._startData;
    }

    set startData(value: Object) {
        // clone the data
        this._startData = DataUtilities.clone(value);
    }

    private _endData: Object = {};

    get endData(): Object {
        return this._endData;
    }

    set endData(value: Object) {
        // clone the data
        this._endData = DataUtilities.clone(value);
    }
}

export class FlowTestContext extends BaseFlowTestContext {
    itemName: string;
    type: TestResultDataType = TestResultDataType.FLOW;

    flowConfiguration: FlowConfiguration;

    constructor(itemId: string, result: string | undefined, flowConfiguration: FlowConfiguration) {
        super(itemId, result);
        this.flowConfiguration = flowConfiguration;
        this.itemName = "Flow Execution";
    }
}

export class FlowSequenceTestContext extends BaseFlowTestContext {
    itemName: string;
    type: TestResultDataType = TestResultDataType.FLOW_SEQUENCE;

    sequence: FlowStepSequence;

    flowTestContext: FlowTestContext;

    constructor(
        itemId: string,
        result: string | undefined,
        sequence: FlowStepSequence,
        flowTestContext: FlowTestContext
    ) {
        super(itemId, result);
        this.sequence = sequence;
        this.flowTestContext = flowTestContext;
        this.itemName = "Sequence: " + sequence.name;
    }
}

export class FlowStepTestContext extends BaseFlowTestContext {
    itemName: string;
    type: TestResultDataType = TestResultDataType.FLOW_STEP;

    step: FlowStepData;
    sequenceTestContext: FlowSequenceTestContext;

    constructor(
        itemId: string,
        result: string | undefined,
        step: FlowStepData,
        sequenceTestContext: FlowSequenceTestContext
    ) {
        super(itemId, result);
        this.step = step;
        this.itemName = "Step: " + step.name + " [" + step.__type + "]";
        this.sequenceTestContext = sequenceTestContext;
    }
}

export class FlowBranchTestData extends BaseTestResultData {
    itemName: string;
    type: TestResultDataType = TestResultDataType.FLOW_BRANCH;

    fromId: string;
    fromPath: string | undefined;
    toId: string;
    hidden = true;
    isReturn: boolean = false;

    constructor(result: string | undefined, fromId: string, fromPath: string | undefined, toId: string) {
        super(FlowBranchTestData.getLineId(fromId, toId, fromPath), result);
        this.fromId = fromId;
        this.fromPath = fromPath;
        this.toId = toId;
        this.itemName = "Flow Branch";
    }

    static getLineId(fromId: string, toId: string, path?: string) {
        return fromId + "-" + toId + (path ? ":" + path : "");
    }
}
